var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d11bfda9db5c3af3fc60e6560a9fe2a3d80b27ec"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["magal@magal-jewelry"]={id:"d11bfda9db5c3af3fc60e6560a9fe2a3d80b27ec"};
      